module.exports = __webpack_public_path__ + "img/4.e1de0954.png";